import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/components/QuotesList.tsx");
